import * as React from "react"
const UAFlag = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={16}
    fill="none"
    {...props}
  >
    <g fillRule="evenodd" clipPath="url(#a)" clipRule="evenodd">
      <path fill="#FFD700" d="M0 0h22v16H0V0Z" />
      <path fill="#0057B8" d="M0 0h22v8H0V0Z" />
    </g>
    <defs>
      <clipPath id="a">
        <rect width={22} height={16} fill="#fff" rx={2} />
      </clipPath>
    </defs>
  </svg>
)
export default UAFlag
